exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-menuIconsBasic-2ehjzjAE {\n  width: 18px;\n  height: 24px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n\n.styles-menuIconsEmphasize-2QJ6PiaS {\n  width: 40px;\n  height: 42px;\n}\n\n.styles-menuIconsExplore-181_772Q {\n  width: 100%;\n  height: 21px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n", ""]);

// exports
exports.locals = {
	"menuIconsBasic": "styles-menuIconsBasic-2ehjzjAE",
	"menuIconsEmphasize": "styles-menuIconsEmphasize-2QJ6PiaS",
	"menuIconsExplore": "styles-menuIconsExplore-181_772Q"
};